(function FranchiseListEmailMarketing($, Adzuki)
{
	"use strict";

	$(document).ready(function onDocumentReady()
	{
		var pages = [
			'FranchiseLists/emailMarketing',
			'FranchiseLists/virtualEventInvites',
		];

		Adzuki.onload(pages, function onListLoad()
		{
			$('.optout-of-email').on('change', function onOptoutCheckboxChange(event)
			{
				var franchise_list_id = $(this).data('id');

				if ($(this).is(':checked')) {
					updateEmailListStatus(franchise_list_id, true);
					return;
				}

				updateEmailListStatus(franchise_list_id, false);
			});
		});
	});

	function updateEmailListStatus(franchise_list_id, optout_from_list)
	{
		var new_status = 0;
		var url        = '/FranchiseLists/updateEmailListOptinStatus/';
		var msg        = 'Your franchise is now opted into the email list.';

		if (optout_from_list) {
			new_status = 1;
			msg        = 'Your franchise is now opted out of the email list.';
		}

		url += franchise_list_id + '/' + new_status;

		Adzuki.Ajax.get(url);
		Adzuki.StatusMessage('Info', msg);
	}
}(jQuery, window.Adzuki || {}));
